import React, { useEffect, useState } from 'react';
import './ServicesHero.css';

const HERO_IMAGE = 'https://images.unsplash.com/photo-1764053430604-d585d1f1dad6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx0ZWNobm9sb2d5JTIwZGlnaXRhbCUyMG5ldHdvcmt8ZW58MXx8fHwxNzY0MjUwMTkxfDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral';

export function ServicesHero() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="services-hero">
      <div 
        className="services-hero-background"
        style={{
          transform: `translateY(${scrollY * 0.5}px)`,
          backgroundImage: `url(${HERO_IMAGE})`,
        }}
      >
        <div className="services-hero-overlay"></div>
        <div className="glow-effect"></div>
      </div>
      
      <div className="services-hero-content">
        <div className="hero-badge fade-in">
          <span>SFrays Technology Solutions</span>
        </div>
        <h1 className="services-hero-title fade-in" style={{ animationDelay: '0.2s' }}>
          Empowering Digital Evolution.<br />One Solution at a Time.
        </h1>
        <p className="services-hero-subtitle fade-in" style={{ animationDelay: '0.4s' }}>
          From automation to cloud solutions, we craft tailored technology experiences that drive growth and innovation.
        </p>
        <div className="services-hero-actions fade-in" style={{ animationDelay: '0.6s' }}>
          <button className="btn btn-primary">Explore Solutions</button>
          <button className="btn btn-secondary">Schedule Consultation</button>
        </div>
      </div>

      {/* Animated particles */}
      <div className="particles">
        {[...Array(20)].map((_, i) => (
          <div 
            key={i} 
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${5 + Math.random() * 10}s`,
            }}
          ></div>
        ))}
      </div>
    </section>
  );
}
